import filterHtmlTemplate from "./FilterPage.ejs"
import flatsHtmlTemplate from "./Flats.ejs"
import makeTemplateFunc from "lodash/template"
import {Preloader} from "../../components"
import {
  getFilterParams,
  getFilterFlats,
  registerPreloader
} from "../../api"
import $ from "jquery";

const filterTemplateFunc = makeTemplateFunc(filterHtmlTemplate);
const flatsTemplateFunc = makeTemplateFunc(flatsHtmlTemplate);

export class FilterPage {
  constructor($container, params, app) {
    this.$container = $container;
    this.filterParams = null;
    this.isChanged = false;
    this.sortingBy = 'housingName';
    this.sortingOrder = 'asc';
    this.app = app;

    registerPreloader(new Preloader(this.$container));
  }

  handleClickCancelFilter(ev) {
    ev.preventDefault();
    if (this.isChanged) {
      this.isChanged = false;
      this.renderFilterTemplate(this.filterParams);
      getFilterFlats(this.app.apiPaths.FILTER_APARTMENTS, this.getFilterParams()).then((response) => {
        this.renderFilterFlats(response);
      });
    }
  }

  handleClickEnterFilter(ev) {
    ev.preventDefault();
    const params = this.getFilterParams();

    getFilterFlats(this.app.apiPaths.FILTER_APARTMENTS, params).then((response) => {
      this.renderFilterFlats(response)
    })
  }

  handleChangeFilter(ev) {
    if (ev.target.tagName === 'INPUT') {
      this.isChanged = true;
      $('#filterClear').removeClass('button_transparent');
    }
  }

  handleClickSort(ev) {
    ev.preventDefault();
    let $this = $(ev.currentTarget),
      by = $this.data('sort-by');

    if (this.sortingBy === by) {
      switch (this.sortingOrder) {
        case 'asc':
          this.sortingOrder = 'desc';
          break;
        case 'desc':
          this.sortingOrder = 'asc';
          break;
      }
    } else {
      this.sortingBy = by;
      this.sortingOrder = 'asc';
    }

    getFilterFlats(this.app.apiPaths.FILTER_APARTMENTS, this.getFilterParams()).then((response) => {
      this.renderFilterFlats(response);
    });
  }

  render() {
    this.$container.addClass('h100');

    getFilterParams(this.app.apiPaths.FILTER_PARAMS).then((response) => {
      this.filterParams = response;
      this.renderFilterTemplate(this.filterParams);

      getFilterFlats(this.app.apiPaths.FILTER_APARTMENTS).then((response) => {
        this.renderFilterFlats(response);
      });

    });

  }

  renderFilterTemplate(response) {
    const $container = this.$container;

    $container.html(filterTemplateFunc({response}));

      $('.js-range').each((i, el) => {
          const $el = $(el);

          $el.ionRangeSlider({
              type: 'double',
              hide_min_max: false,
              hide_from_to: true,
              onStart: function (data) {
                  setTimeout(function () {
                      setVlues(data.from, data.to, $el);
                  }, 0);
              },
              onChange: function (data) {
                  setVlues(data.from, data.to, $el);
              }
          });
      });

      function setVlues(from, to, obj) {
          obj.parents('.range').find('.irs-min').html(from);
          obj.parents('.range').find('.irs-max').html(to);
      }

    $container[0].onchange = this.handleChangeFilter.bind(this);
    $container.find('#filterClear').on('click', this.handleClickCancelFilter.bind(this));
    $container.find('#filterEnter').on('click', this.handleClickEnterFilter.bind(this));

  }

  renderFilterFlats(response) {
    this.$container.find('.flats-table').html(flatsTemplateFunc({response}));
    this.$container.find('.js-sort').on('click', this.handleClickSort.bind(this));

    this.app.initScroll();

    $('.js-flats-list').height($(window).height() - $('.content__header').outerHeight(true) - $('.js-flats-row').outerHeight(true));
  }

  getFilterParams() {
    const data = {rooms: [], finish:[], housingShortNames:[]};

    this.$container.find('.js-range').each(function () {
      const val = this.value.split(';');

      switch (this.name) {
        case 'price':
          data.priceFrom = parseInt(val[0] * 1000000, 10);
          data.priceTo = parseInt(val[1] * 1000000, 10);
          break;
        case 'space':
          data.spaceFrom = parseInt(val[0], 10);
          data.spaceTo = parseInt(val[1], 10);
          break;
        case 'floor':
          data.floorFrom = parseInt(val[0], 10);
          data.floorTo = parseInt(val[1], 10);
          break;
      }
    });

    this.$container.find('.js-room').each(function () {
      if (this.checked) {
        data.rooms.push(parseInt(this.value, 10));
      }
    });
    
    this.$container.find('.js-finish').each(function () {
      if (this.checked) {
        data.finish.push(this.value);
      }
    });
    
    this.$container.find('.js-housing-short-name').each(function () {
      if (this.checked) {
        data.housingShortNames.push(parseInt(this.value, 10));
      }
    });

    data.by = this.sortingBy;
    data.order = this.sortingOrder;

    return data;
  }
}



// WEBPACK FOOTER //
// ./js/pages/FilterPage/FilterPage.js